import React from "react";
import Marquee from "react-fast-marquee";

const TextSliderAmazon = () => {
  return (
    <div className='text-slider-section overflow-hidden bg-light-700 py-9'>
      <div className='text-slider d-flex align-items-center gap-4'>
        <Marquee
          speed={150}
          pauseOnHover={true}
          className='Marquee_text-slider'
        >
          <div className='d-flex flex-nowrap flex-shrink-0 flx-align gap-32'>
            <span className='flex-shrink-0'>
              <img src='assets/images/icon/star-color.png' alt='' />
            </span>
            <h5 className='text-white flex-grow-1 mb-0 fw-medium'>
            Locate a store to start shopping
            </h5>
          </div>
          <div className='d-flex flex-nowrap flex-shrink-0 flx-align gap-32'>
            <span className='flex-shrink-0'>
              <img src='assets/images/icon/star-color.png' alt='' />
            </span>
            <h5 className='text-white flex-grow-1 mb-0 fw-medium'>
            Explore stores and start buying
            </h5>
          </div>
          <div className='d-flex flex-nowrap flex-shrink-0 flx-align gap-32'>
            <span className='flex-shrink-0'>
              <img src='assets/images/icon/star-color.png' alt='' />
            </span>
            <h5 className='text-white flex-grow-1 mb-0 fw-medium'>
            Find a seller's store to start shopping
                        </h5>
          </div>
          <div className='d-flex flex-nowrap flex-shrink-0 flx-align gap-32'>
            <span className='flex-shrink-0'>
              <img src='assets/images/icon/star-color.png' alt='' />
            </span>
            <h5 className='text-white flex-grow-1 mb-0 fw-medium'>
            Locate a store to start shopping
                        </h5>
          </div>
          <div className='d-flex flex-nowrap flex-shrink-0 flx-align gap-32'>
            <span className='flex-shrink-0'>
              <img src='assets/images/icon/star-color.png' alt='' />
            </span>
            <h5 className='text-white flex-grow-1 mb-0 fw-medium'>
            Explore stores and start buying
                        </h5>
          </div>
          <div className='d-flex flex-nowrap flex-shrink-0 flx-align gap-32'>
            <span className='flex-shrink-0'>
              <img src='assets/images/icon/star-color.png' alt='' />
            </span>
            <h5 className='text-white flex-grow-1 mb-0 fw-medium'>
              {" "}
              Find a seller's store to start shopping
              </h5>
          </div>
        </Marquee>
      </div>
    </div>
  );
};

export default TextSliderAmazon;
